import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/store/hooks/Redux'
import { selectNotifications } from '../../../app/store/reducers/AuthSlice'
import { showAlert } from '../../../app/store/reducers/AppSlice'
import { usePostSiteHideNotificationMutation } from '../../../app/api'
import { useTranslation } from 'react-i18next'

export const useNotifications = () => {
  const { t } = useTranslation()
  const notifications = useAppSelector(selectNotifications)
  const dispatch = useAppDispatch()

  const [hideNotification] = usePostSiteHideNotificationMutation()

  useEffect(() => {
    if (notifications && notifications.some(({ type }) => type === 'affiliate_rule_sync_done')) {
      const notification = notifications.find(({ type }) => type === 'affiliate_rule_sync_done')

      if (notification?.data) {
        dispatch(
          showAlert({
            message: `Successfully created ${notification.data.affiliates_count} affiliate partners for ${notification.data.ads_count} ads over the past 60 days. See the PPC Compliance Report for details.`,
            type: 'success',
            timeout: 5000,
            onClose: () => {
              hideNotification({ id: notification.id })
            },
          }),
        )
      }
    }
  }, [notifications, dispatch])

  useEffect(() => {
    if (
      notifications &&
      notifications.some(({ type }) => type === 'stripe_subscription_successfully_renew')
    ) {
      const notification = notifications.find(
        ({ type }) => type === 'stripe_subscription_successfully_renew',
      )

      if (notification?.id) {
        dispatch(
          showAlert({
            message: t('notifications.paymentSuccess'),
            type: 'success',
            timeout: 5000,
            onClose: () => {
              hideNotification({ id: notification.id })
            },
          }),
        )
      }
    }
  }, [notifications, dispatch])
}
